import React from "react";
import Navbar from "components/Navbars/Navbar.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import "./style.scss";

const PrivacyPolicy = () => {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  return (
    <>
      <Navbar />
      <div
        className="privacy-container"
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "150px 20px",
          lineHeight: "1.6",
        }}
      >
        <h1>Privacy and Policy</h1>
        <h2>1. Information We Collect</h2>
        <p>
          Our company only collects personal information that you voluntarily
          provide when accessing our website, registering for events, or
          submitting forms. This may include details such as your name, company,
          contact information, and other relevant data required for registration
          or participation.
        </p>
        <p>
          We do not collect personal information without your knowledge. If no
          information is submitted, we do not gather or store any data about
          you.
        </p>
        <p>
          We may use essential website technologies (such as cookies or similar
          tools) solely to support functionality and improve user experience,
          where applicable.
        </p>
        <h2>2. How We Use Your Information</h2>
        <p>
          We use the information you provide to deliver and manage our event
          services. This includes:
        </p>
        <ul>
          <li>Processing event registrations</li>
          <li>Communicating important event updates and information</li>
          <li>
            Facilitating networking opportunities between participants,
            partners, or sponsors
          </li>
          <li>Improving our events and services</li>
        </ul>
        <p>
          If you register for an event, certain information (such as your name,
          company, role and any other information you voluntarily provide) may
          be shared with other participants or partners for legitimate business
          and networking purposes.
        </p>
        <p>
          By submitting your information, you consent to its use for these
          purposes.
        </p>
        <h2>3. Data Sharing</h2>
        <p>
          We do not sell or rent your personal information. Your data may be
          shared only with:
        </p>
        <ul>
          <li>
            Trusted service providers supporting our operations (e.g., event
            platforms, email services)
          </li>
          <li>
            Event partners or sponsors, where relevant to the event experience
          </li>
          <li>Legal authorities, if required by law</li>
        </ul>
        <p>
          All third parties are expected to handle your data securely and
          responsibly.
        </p>
        <h2>4. Data Security</h2>
        <p>
          We implement appropriate security measures, including restricted
          access to sensitive areas of our website through secure login
          credentials. While we strive to protect your data, please note that no
          method of transmission over the internet is completely secure.
        </p>
        <p>
          Our website may contain links to third-party services. We are not
          responsible for the privacy practices or content of those external
          websites.
        </p>
        <h2>5. Payment Processing</h2>
        <p>
          For payments (such as event fees), we use secure third-party payment
          gateways provided by our banking or payment partners. When you make a
          payment, your financial information is processed directly by the
          payment provider and is not stored on our servers.
        </p>
        <p>
          We take reasonable steps to ensure that all transactions are handled
          securely and that your information is protected.
        </p>
        <h2>6. Your Consent</h2>
        <p>
          By using our website and submitting your information, you agree to the
          collection and use of your data as described in this policy.
        </p>
        <h2>7. Your Rights </h2>
        <p>You have the right to: </p>
        <ul>
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Object to or restrict processing </li>
          <li>Withdraw consent at any time</li>
        </ul>
        <p>
          To exercise these rights, contact us at:{" "}
          <a rel="noopener" href="#!">
            customerservice@fibsglobalconference.com
          </a>
        </p>
        <h2>8. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated effective date.
        </p>
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or how your
          information is handled, please contact us:
        </p>
        <p>
          Email:{" "}
          <a rel="noopener" href="#!">
            customerservice@fibsglobalconference.com
          </a>
        </p>
        <div
          className="border-top border-2 border-secondary my-4 my-lg-5 aos-init aos-animate"
          data-aos="fade-up"
        ></div>
      </div>
      <DarkFooter />
    </>
  );
};

export default PrivacyPolicy;
